var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mt-16",attrs:{"width":"512px"}},[_c('v-card-title',[_vm._v(" Work in progress! ")]),_c('v-card-text',[(false)?_c('router-link',{attrs:{"to":"/download"}},[_vm._v("Download")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }